<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title></v-toolbar-title>
      <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
      <FundingActions
        v-if="selected.length"
        :status="status"
        :applications="selected"
        @refetch="fundingList"
      />
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        @keypress="fundingList"
      ></v-text-field>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div v-if="!isLoggedIn">
      <v-alert
        :value="true"
        type="warning"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
    </div>
    <div v-if="alertMsg">
      <v-alert
        v-if="error == 0 && statusCode == 200"
        :value="true"
        type="success"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 204"
        :value="true"
        type="info"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
        :value="true"
        type="warning"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 500"
        :value="true"
        type="error"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
    </div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="indexData.data"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      disable-initial-sort
      :loading="loading"
      class="elevation-1"
    >
      <!-- <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear> -->

      <!-- Selected rows test -->
      <template v-slot:headers="props">
        <tr>
          <th v-if="status < 8">
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.stop="toggleAll"
              class="pl-2"
            ></v-checkbox>
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ header.text }}
                </span>
              </template>
              <span>
                {{
                  header.date
                    ? dateTitle
                    : header.title
                    ? header.title
                    : header.text
                }}
              </span>
            </v-tooltip>
          </th>
        </tr>
      </template>
      <template
        v-if="indexData.data && indexData.data.length > 0"
        v-slot:items="props"
      >
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td v-if="status < 8">
            <v-checkbox
              :input-value="props.selected"
              primary
              hide-details
              class="pl-2"
            ></v-checkbox>
          </td>
          <td>{{ props.item.id }}</td>
          <td class="textUpper" :title="props.item.loan_product_title">
            {{
              props.item.loan_product_title
                .split(/\s/)
                .reduce((response, word) => (response += word.slice(0, 1)), "")
            }}
          </td>
          <!-- <td>
          <ImgLazyLoad
            v-if="props.item.document && props.item.document.photo"
            class="profileImage"
            :src="`${photoUrl}/${props.item.document.photo}`"
          />
        </td> -->
          <td
            class="ttc link"
            :title="props.item.user_name"
            @click="goToUserDetails(props.item.phone)"
          >
            <TextAbbr :text="props.item.user_name" />
          </td>
          <td>
            <Phone :phone="props.item.phone" />
          </td>
          <td>
            <CreditScore :creditScore="props.item.credit_score" />
          </td>
          <td>{{ props.item.gini_score ? props.item.gini_score : "-" }}</td>
          <td><Date :date="fundingDate(props.item)" /></td>

          <td>
            <BDTCurrencyFormat :amount="props.item.amount" />
          </td>
          <td>{{ props.item.duration }}</td>
          <td><BDTCurrencyFormat :amount="props.item.disbursed_amount" /></td>
          <!--<td>{{ props.item.monthly_funding_due }}</td>
         <td>{{ props.item.monthly_community_fee }}</td>
        <td>{{ props.item.monthly_payment_gateway_fee }}</td> -->
          <td>
            <BDTCurrencyFormat :amount="props.item.total_monthly_payable" />
          </td>
          <td>
            <BDTCurrencyFormat :amount="props.item.annual_interest_rate" />
          </td>
          <!-- <td>{{ props.item.total_full_term_payable }}</td> -->
          <td>
            <BDTCurrencyFormat :amount="props.item.total_full_term_payable" />
          </td>

          <td @click="props.selected = !props.selected">
            <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="editItem(props.item)"
              >
                visibility
              </v-icon>
            </template>
            <span>view</span>
          </v-tooltip> -->
            <!-- <router-link
            :to="{
              name: 'FundingDetails',
              params: { id: props.item.id },
            }"
            target="_blank"
            class="mt-1"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }"> -->
            <!-- <v-icon
                  small
                  color="primary"
                  class="mr-2"
                  label="Details"
                  v-on="on"
                >
                  content_paste_go
                </v-icon> -->
            <!-- <v-btn
              small
              @click="goToFundingDetails(props.item.id)"
              color="primary"
              class="mt-2"
            >
              View
            </v-btn> -->
            <a
              :href="`${newFrontEndUrl}/funding-details/${props.item.id}/funding/summary`"
              target="_blank"
              color="primary"
              class="mt-2"
            >
              <v-btn small color="primary">View</v-btn>
            </a>
            <!-- </template>
              <span>Details</span>
            </v-tooltip>
          </router-link> -->
          </td>
        </tr>
      </template>
      <template v-else v-slot:no-data>
        <div v-if="errorMsg">
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
      <!-- End Selected rows test -->
      <template v-slot:pageText>
        {{ pagination.rowsPerPage }}
        Rows {{ indexData.from }} - {{ indexData.to }} of {{ indexData.total }}
      </template>
    </v-data-table>

    <template>
      <div class="text-xs-center" v-if="indexData.last_page">
        <v-pagination
          v-model="indexData.current_page"
          :length="indexData.last_page"
          @input="fundingList"
        ></v-pagination>
      </div>
    </template>
    <div class="text-xs-center pa-3" v-if="status == 7">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        large
        @click="downloadExcel"
        :loading="downloading"
      >
        Download Excel (City Live)
      </v-btn>
      <v-btn
        color="primary"
        large
        @click="downloadExcelBrac"
        :loading="downloading2"
      >
        Download Excel (BRAC Corpnet)
      </v-btn>
      <v-spacer></v-spacer>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import BDTCurrencyFormat from "@/components/BDTCurrencyFormat";
  import CreditScore from "@/components/CreditScore";
  import Date from "@/components/Date";
  import TextAbbr from "@/components/TextAbbr";
  import Phone from "@/components/Phone";
  import api from "../api/shadhin";
  import downloadExcelFile from "@/lib/downloadExcelFile";
  import FundingActions from "@/components/FundingActions";
  // import ImgLazyLoad from "@/components/ImgLazyLoad";
  export default {
    components: {
      BDTCurrencyFormat,
      CreditScore,
      Date,
      TextAbbr,
      Phone,
      // ImgLazyLoad,
      FundingActions,
    },
    props: [
      "loanProductId",
      "status",
      "search",
      "page",
      "rowsPerPage",
      "scroll",
      "reload",
      "dateTitle",
    ],
    data: () => ({
      photoUrl: process.env.VUE_APP_PHOTO_URL,
      newFrontEndUrl: process.env.VUE_APP_NEW_FRONTEND_URL,
      alertMsg: false,
      sl: 1,
      selected: [],
      headers: [
        { text: "Id", value: "id", title: "Funding Id" },
        {
          text: "Product",
          value: "loan_product_id",
          title: "Loan Product Name",
        },
        // { text: "Photo", value: "photo", sortable: false },
        { text: "Name", value: "user_name" },
        { text: "Phone", value: "phone" },
        {
          text: "CS",
          value: "credit_score",
          title: "Credit Score",
        },
        {
          text: "GS",
          value: "gini_score",
          title: "Gini Score",
        },
        { text: "Date", value: "created_at", date: true },

        { text: "Amount", value: "amount" },
        { text: "Duration", value: "duration" },
        {
          text: "Disbursed",
          value: "disbursed_amount",
          title: "Disbursed Amount",
        },
        // { text: "Funding Due", value: "monthly_funding_due" },
        // { text: "Community Fee", value: "monthly_community_fee" },
        // { text: "Pmnt Gateway Fee", value: "monthly_payment_gateway_fee" },
        { text: "EMI", value: "total_monthly_payable" },
        {
          text: "APR",
          value: "annual_interest_rate",
          title: "Annual Percentage Rate",
        },
        {
          text: "Total Payable",
          value: "total_full_term_payable",
        },

        { text: "Actions", value: "name", sortable: false },
      ],
      loading: true,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        // sortBy: "id",
      },
      currentPage: 1,
      resetCurrentPage: false,
      currentStatus: 0,
      rowsPerPageItems: [10, 20, 50, 100, 500],

      defaultItem: {},
      downloading: false,
      downloading2: false,
      downloadURL: "download/citylive-excel",
      downloadURL2: "download/brac-excel",
    }),

    computed: {
      ...mapGetters([
        "indexData",
        "isLoggedIn",
        "error",
        "statusCode",
        "errorMsg",
        "investorAgreement",
        "investeeAgreement",
        "userImage",
        "docImage",
        "backRouteActive",
      ]),
      formTitle() {
        return this.editedIndex === -1 ? "New Application" : "View Application";
      },
      rowsPerPageValue() {
        return this.pagination.rowsPerPage;
      },
    },

    watch: {
      rowsPerPageValue() {
        this.resetCurrentPage = true;
      },
      pagination() {
        this.fundingList();
      },
      dialog(val) {
        val || this.close();
      },
      loanProductId() {
        this.fundingList();
      },
      reload() {
        this.fundingList();
        this.$emit("reloadCompleted");
      },
    },

    methods: {
      toggleAll() {
        if (this.selected.length === this.indexData.data.length)
          this.selected = [];
        else this.selected = this.indexData.data.slice();
      },
      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      fundingDate(funding) {
        switch (this.status) {
          case 1:
            return funding.created_at;
          case 2:
            return funding.verified_at
              ? funding.verified_at
              : funding.updated_at;
          case 3:
            return funding.rejected_at
              ? funding.rejected_at
              : funding.updated_at;
          case 5:
            return funding.invested_at
              ? funding.invested_at
              : funding.updated_at;
          case 6:
            return funding.agree_accepted_at
              ? funding.agree_accepted_at
              : funding.updated_at;
          case 8:
            return funding.disbursed_at
              ? funding.disbursed_at
              : funding.updated_at;
          case 10:
            return funding.canceled_at
              ? funding.canceled_at
              : funding.updated_at;
          case 11:
            return funding.defaulted_at
              ? funding.defaulted_at
              : funding.updated_at;
          default:
            return funding.updated_at;
        }
      },

      async fundingList() {
        this.loading = true;

        this.currentPage = this.resetCurrentPage
          ? 1
          : this.backRouteActive && this.page
          ? this.page
          : this.currentStatus != this.status
          ? this.currentPage
          : this.indexData.current_page;

        this.pagination.rowsPerPage =
          this.backRouteActive && this.rowsPerPage
            ? parseInt(this.rowsPerPage)
            : this.pagination.rowsPerPage;

        try {
          await this.$store.dispatch("getFundingListLoanProduct", [
            this.loanProductId,
            "funding-list",
            this.status,
            this.search,
            this.currentPage,
            this.pagination.rowsPerPage,
          ]);
          document.documentElement.scrollTop =
            this.backRouteActive && this.scroll ? this.scroll : "";
          this.$store.commit("resetBackPageActive");
        } catch (e) {
          //
        } finally {
          this.loading = this.indexData ? false : true;
          this.dialog = false;
          this.currentStatus = this.status;
        }
      },

      goToUserDetails(id) {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        const goUrl = `/user/${id}`;
        const backUrl = `/funding?search=${this.search}&page=${
          this.indexData.current_page
        }&rowsPerPage=${
          this.pagination.rowsPerPage
        }&scroll=${currentScroll.toFixed(3)}`;
        this.$emit("goto", {
          goUrl,
          backUrl,
        });
      },

      goToFundingDetails(id) {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        const goUrl = `/funding/${id}`;
        const backUrl = `/funding?search=${this.search}&page=${
          this.indexData.current_page
        }&rowsPerPage=${
          this.pagination.rowsPerPage
        }&scroll=${currentScroll.toFixed(3)}`;
        this.$emit("goto", {
          goUrl,
          backUrl,
        });
      },

      async downloadExcel() {
        this.downloading = true;

        try {
          const response = await api.downloadFile(this.downloadURL);
          downloadExcelFile(response.data, "funding-list-city-live.xlsx");
        } catch (err) {
          // We need to show this as a dialog instead of alert message.
          alert("Something went wrong. Please try again later.");
        }

        this.downloading = false;
      },

      async downloadExcelBrac() {
        this.downloading2 = true;

        try {
          const response = await api.downloadFile(this.downloadURL2);
          downloadExcelFile(response.data, "funding-list-brac-corpnet.xlsx");
        } catch (err) {
          // We need to show this as a dialog instead of alert message.
          alert("Something went wrong. Please try again later.");
        }

        this.downloading2 = false;
      },
    },
  };
</script>
<style scoped>
  .v-progress-circular {
    margin: 1rem;
  }

  .imageResize {
    width: auto;
    height: auto;
  }

  .no-underline {
    text-decoration: none;
  }

  .profileImage {
    max-width: 30px;
    height: auto;
    max-height: 50px;
  }

  .closeDialogBtn {
    position: absolute;
    right: 20px;
  }

  .elementCenter a {
    text-decoration: none;
    margin: 15px auto 0 !important;
  }

  .ttc {
    text-transform: capitalize;
  }

  td {
    white-space: nowrap;
  }

  .link {
    color: #229;
    cursor: pointer;
  }
</style>
